// extracted by mini-css-extract-plugin
export var aside = "post-module--aside--Uow7s";
export var base = "post-module--base--3b5je";
export var main = "post-module--main--AE--R";
export var root = "post-module--root--3namP";
export var sns_share = "post-module--sns_share--x9aP1";